import { getWindowLocationHref } from '../routing/getWindowLocationHref';
import { getQueryParam } from '../routing/getQueryParam';
import { isHubSpotHost } from '../utils/urls';
export const getLoginRedirectUrl = () => {
  const loginRedirectUrl = getQueryParam('loginRedirectUrl');
  if (isHubSpotHost(loginRedirectUrl)) {
    return loginRedirectUrl;
  }
  return getWindowLocationHref();
};